import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import querystring from 'querystring'
axios.defaults.withCredentials = true
let requestMap = {}
var ajaxFun = function (type, url, data, $btn) {
  let keyName = '__' + url
  data = data || {}
  // 切换按钮状态
  let disabledBtn = (flag) => {
    if ($btn === undefined) {
      return
    }
    let type = (typeof $btn).toLowerCase()
    // btn 对象
    if (type === 'object') {
      if ($btn && $btn.$el) {
        $btn = $btn.$el
      }
      if (flag) {
        $btn.setAttribute('disabled', 'disabled')
      } else {
        $btn.removeAttribute('disabled')
      }
    }
    if (flag) {
      requestMap[keyName] = 1
    } else {
      delete requestMap[keyName]
    }
  }
  // 加入请求追踪
  let timestamp = Date.parse(new Date()) + ''
  let randomNumber = Math.random().toString(36).substr(2, 15)
  let randomStr = 'bg' + timestamp + randomNumber
  let hyphen = (url.indexOf('?') > -1 ? '&' : '?')
  data = Object.assign({'_trc': randomStr, '__isRP': true}, data || {})
  // 防重复请求
  if ($btn !== undefined && requestMap[keyName]) {
    return
  }

  if (type === 'post' && !data.__isRP) {
    data = querystring.stringify(data) // 这是form data 需要的格式
  }
  if (type === 'get') {
    data = {
      params: data
    }
  }
  disabledBtn(true)
  if (type === 'jsonp') {
    return axios({url: url + hyphen + querystring.encode(data), adapter: jsonpAdapter}).then((rs) => {
      return rs.data
    }).finally(() => {
      disabledBtn(false)
    })
  } else {
    return axios[type](url, data).then((rs) => {
      return rs.data
    }).finally(() => {
      disabledBtn(false)
    })
  }
}
var ajax = {
  get: (url, data, $btn) => ajaxFun('get', url, data, $btn),
  post: (url, data, $btn) => ajaxFun('post', url, data, $btn),
  jsonp: (url, data, $btn) => ajaxFun('jsonp', url, data, $btn)
}
var interceptors = {
  request: {
    use: function (callback, errorCallback) {
      axios.interceptors.request.use(config => {
        if (config.method === 'post') {
          if (!config.data.__isRP) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
          }
        }
        return callback(config)
      }, error => {
        // return Promise.reject(error)
        return errorCallback(error)
      })
    }
  },
  response: {
    use: function (callback, errorCallback) {
      axios.interceptors.response.use(config => {
        return callback(config)
      }, error => {
        // return Promise.reject(error)
        return errorCallback(error)
      })
    }
  }
}

var setOpt = function (opt) {
  Object.assign(axios.defaults, opt)
}
export {
  ajax,
  axios,
  interceptors,
  setOpt
}



// WEBPACK FOOTER //
// ./src/components/mc-ui/ajax.js